export default __webpack_public_path__ + "static/media/personalCategories_sample.7c51dc7f.jpg";